import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-not-found',
  imports: [],
  templateUrl: './not-found.html',
  styleUrl: './not-found.scss',
})
export class NotFound {
  constructor(
    private readonly router: Router,
    private readonly _auth: AuthService,
  ) {}
  redirect(): void {
    this._auth.getUserProfile().subscribe({
      next: (res: any) => {
        if (res?.role == 'User') {
          this.router.navigate(['/agent/chat']);
        } else {
          this.router.navigate(['/kpi-explorer']);
        }
      },
      error: (err: any) => {},
    });
  }
}
